import { z } from "zod";

const checklistItemTypeDataSchema = z.object({
    sceneObjectType: z.literal("ChecklistItem"),
    checklistItemId: z.number().int().nonnegative().nullable(),
    imageUrl: z.string().nullable(),
    color: z.string().nullable()
});

const apiSceneObjectTypeDataSchema = z.discriminatedUnion("sceneObjectType", [
    checklistItemTypeDataSchema,
]);

export default apiSceneObjectTypeDataSchema;
